import loadItemState from './helpers/loadItemState';
import updateLoadedItemState from '../actions/updateLoadedItemState';
import { mutator } from 'satcheljs';
import type Item from 'owa-service/lib/contract/Item';
import type ItemReadingPaneViewState from '../store/schema/ItemReadingPaneViewState';

interface UpdateLoadedItemStateActionMessage {
    itemId: string;
    loadedItem: Item;
    itemReadingPaneViewState: ItemReadingPaneViewState;
}

/**
 *  Updates the itemReadingPaneViewState with item info
 *  and also updates the loading states
 */
export default mutator(
    updateLoadedItemState,
    function updateLoadedItemStateMutator(actionMessage: UpdateLoadedItemStateActionMessage): void {
        const { itemId, loadedItem, itemReadingPaneViewState } = actionMessage;

        if (!itemReadingPaneViewState || itemReadingPaneViewState.itemId !== itemId) {
            // If null view state or a different item has been loaded, skip.
            return;
        }

        itemReadingPaneViewState.itemViewState = loadItemState(itemId, loadedItem);
        itemReadingPaneViewState.loadingState = itemReadingPaneViewState.loadingState || {
            ...itemReadingPaneViewState.itemViewState.loadingState,
        };
        itemReadingPaneViewState.loadingState.isLoading = false;
        itemReadingPaneViewState.loadingState.hasLoadFailed = loadedItem ? false : true;
    }
);
